/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import type {
  HotelDetailViewFlags,
  HotelListingFlags,
  HotelsConfirmationFeatureFlags,
  HotelSearchViewFlags,
  HotelTripDetailViewFlags,
} from '../types';

// Feature flag key for home hotel entrypoints redirect to new search pages
export const FEATURE_FLAG_HOTEL_HOME_TILE_REDIRECT_ENABLED =
  'hotel_home_tile_redirect_new_search_enabled' as const;

export const HOTELS_LISTING_FEATURE_FLAGS =
  'hotels_listing_feature_flags' as const;

// Legacy fallback key during search/listing flags merge rollout.
export const HOTELS_SEARCH_VIEW_FLAGS = 'hotels_search_feature_flags' as const;

export const HOTELS_DETAIL_VIEW_FEATURE_FLAGS =
  'hotels_details_feature_flags' as const;

export const HOTELS_TRIP_DETAIL_VIEW_FEATURE_FLAGS =
  'hotels_trip_details_feature_flags' as const;

export const HOTELS_CONFIRMATION_FEATURE_FLAGS =
  'hotels_confirmation_feature_flags' as const;

export const HOTEL_LISTING_FLAGS_DEFAULT: HotelListingFlags = {
  hotel_banner_enabled: false,
  hotel_map_enabled: false,
  hotel_popular_filter_enabled: false,
  hotel_sortBy_filter_enabled: false,
  hotel_searchPropertyName_filter_enabled: false,
  hotel_paymentPolicy_filter_enabled: false,
  hotel_priceRange_filter_enabled: false,
  hotel_priceslider_filter_enabled: false,
  hotel_promotions_filter_enabled: false,
  hotel_hotelClass_filter_enabled: false,
  hotel_propertyType_filter_enabled: false,
  hotel_guestRating_filter_enabled: false,
  hotel_location_filter_enabled: false,
  hotel_neighbouhood_filter_enabled: false,
  hotel_amenities_filter_enabled: false,
  hotel_list_default_page_size: 100,
  enable_favourite_map_marker: false,
  enable_filters_on_map: false,
  enable_saved_button: false,
  enable_flyer_discount_banner: false,
  hotel_meals_filter_enabled: false,
  hotel_enable_portal_usage: false,
};

export const HOTEL_SEARCH_VIEW_FLAGS_DEFAULT: HotelSearchViewFlags = {
  enable_hotel_feature_destination: false,
  hotel_move_list_page_enabled: false,
  hotel_recent_searches_enabled: false,
  hotel_recommendation_enabled: false,
  hotel_search_voucher_enabled: false,
  hotel_group_parameter_enabled: false,
  enable_hotel_search_banner: false,
  hotel_popular_searches_enabled: false,
  hotel_combined_date_field_enabled: false,
  hotel_cloudflare_image_optimization_enabled: false,
};

// Merged payload contract:
// hotels_listing_feature_flags can include both listing and search-view keys.
export const HOTEL_MERGED_LISTING_AND_SEARCH_FLAGS_DEFAULT = {
  ...HOTEL_LISTING_FLAGS_DEFAULT,
  ...HOTEL_SEARCH_VIEW_FLAGS_DEFAULT,
} as const;

export const HOTEL_DETAIL_VIEW_FLAGS_DEFAULT: HotelDetailViewFlags = {
  hotel_move_details_page_enabled: false,
  hotel_guest_reviews_enabled: false,
  hotel_shortlist_enabled: false,
  hotel_map_enabled: false,
  hotel_room_details_pre_checkout_enabled: false,
  hotel_room_filter_enabled: false,
};

export const HOTEL_CHECKOUT_FEATURE_FLAGS_DEFAULT: HotelsConfirmationFeatureFlags =
  {
    hotels_confirmation_feature_flags: false,
    hotel_move_confirmation_page_enabled: false,
    hotel_confirmation_cancellation_policy_enabled: false,
    hotel_confirmation_nps_enabled: false,
  };

export const HOTEL_TRIP_DETAIL_VIEW_FLAGS_DEFAULT: HotelTripDetailViewFlags = {
  hotel_move_tripdetails_page_enabled: false,
};
